import { sm, xs } from "../../../BreakPoints";
import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(94vw, 700px);
  outline: none;
`;

export const Surface = styled.div`
  border-radius: 0.7rem;
  border: 1px solid var(--line-mid);
  background: var(--surface-soft);
  box-shadow: 0 20px 38px rgba(15, 43, 95, 0.18);
  padding: 0.75rem;
  display: grid;
  gap: 0.75rem;

  ${xs({
    padding: "0.75rem",
    borderRadius: "0.8rem",
  })}
`;

export const Header = styled.div`
  display: grid;
  gap: 0.18rem;
`;

export const HeaderTitle = styled.h3`
  color: var(--deep-navy);
  font-size: 1.15rem;
`;

export const HeaderText = styled.p`
  color: var(--text-muted);
  font-size: 0.84rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 0.95rem;

  ${sm({
    flexDirection: "column",
    alignItems: "stretch",
  })}
`;

export const TitleCard = styled.div`
  min-width: 18.5rem;
  width: 100%;
  max-width: 23rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  ${sm({
    maxWidth: "100%",
    minWidth: "100%",
  })}
`;

export const Panel = styled.div`
  background-image: url(${(props) => props.link});
  background-size: cover;
  background-position: center center;
  border-radius: 0.75rem;
  box-shadow: rgba(5, 15, 35, 0.26) 0 14px 26px;
`;

export const PanelWrapper = styled.div`
  border-radius: 0.75rem;
  background: linear-gradient(180deg, rgba(8, 25, 58, 0.36), rgba(8, 25, 58, 0.7));
  position: relative;
  width: 100%;
  min-height: 7.8rem;
  display: flex;
  flex-direction: column;
  padding: 0.7rem;
  justify-content: space-between;
  gap: 0.55rem;
`;

export const TitleInput = styled.input`
  width: calc(100% - 2rem);
  color: white;
  padding: 0.45rem 0.5rem;
  border-radius: 0.4rem;
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background-color: rgba(255, 255, 255, 0.2);
  transition: border-color 0.2s ease, background-color 0.2s ease;
  font-size: 0.94rem;
  font-weight: 700;

  &::placeholder {
    font-weight: 600;
    color: rgba(244, 244, 244, 0.95);
  }

  &:focus {
    border-color: rgba(255, 255, 255, 0.85);
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

export const MemberWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  gap: 0.35rem;
`;

export const MemberInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  border-radius: 0.5rem;
  padding-left: 0.45rem;
  background-color: rgba(255, 255, 255, 0.2);
  transition: background-color 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.28);

  &:hover {
    background-color: rgba(255, 255, 255, 0.28);
  }
`;

export const MemberIcon = styled.div`
  color: rgba(242, 247, 255, 0.95);
  display: flex;
  align-items: center;
  margin-bottom: 1px;
`;

export const MemberInput = styled.input`
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  color: white;
  padding: 0.45rem 0.3rem;
  font-weight: 500;
  font-size: 0.83rem;

  &::placeholder {
    color: rgba(238, 244, 255, 0.94);
  }
`;

export const AddButton = styled.button`
  color: rgba(255, 255, 255, 0.88);
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.26);
  background: rgba(255, 255, 255, 0.22);
  height: 2.05rem;
  width: 2.05rem;
  border-radius: 0.52rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.24);
    color: rgba(255, 255, 255, 1);
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.45rem;
  right: 0.45rem;
  height: 1.8rem;
  width: 1.8rem;
  border: none;
  border-radius: 0.5rem;
  background: rgba(0, 0, 0, 0.25);
  color: rgba(255, 255, 255, 0.88);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.42);
  }
`;

export const CreateButton = styled.button`
  width: 100%;
  font-family: var(--font-display);
  font-weight: 700;
  padding: 0.7rem;
  border: none;
  border-radius: 0.5rem;
  color: white;
  font-size: 0.92rem;
  cursor: pointer;
  background: var(--brand-blue);
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  box-shadow: 0 10px 18px rgba(21, 71, 171, 0.2);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 20px rgba(21, 71, 171, 0.3);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.56;
    transform: none;
    box-shadow: none;
  }
`;

export const CloseIcon = styled.div``;

export const PhotosPane = styled.div`
  width: 100%;
  max-width: 18rem;
  display: grid;
  gap: 0.5rem;

  ${sm({
    maxWidth: "100%",
  })}
`;

export const PhotosTitle = styled.p`
  margin: 0;
  color: var(--deep-navy);
  font-size: 0.88rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const PhotosCard = styled.div`
  width: 100%;
  min-height: 96px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.42rem;
`;

export const PhotoWrapper = styled.button`
  background-image: url(${(props) => props.link});
  border: 1px solid rgba(59, 99, 247, 0.2);
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 0.45rem;
  background-position: center center;
  background-size: cover;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(59, 99, 247, 0.45);
  }

  ${xs({
    width: "2.6rem",
    height: "2.6rem",
  })}
`;

export const Photo = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 0.62rem;
  background-color: ${(props) =>
    props.show ? "rgba(26, 35, 64, 0.72)" : "rgba(255, 255, 255, 0.0)"};
  transition: background-color 0.15s ease-in;

  ${PhotoWrapper}:hover & {
    background-color: rgba(26, 35, 64, 0.5);
  }
`;

export const DoneIconWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 0.62rem;
  display: ${(props) => (props.show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  color: white;
`;

export const ChipWrapper = styled.div`
  background: rgba(26, 35, 64, 0.55);
  padding: 0 0.55rem 0.6rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.35rem;
  border-radius: 0 0 0.75rem 0.75rem;
`;
